import { render, staticRenderFns } from "./ViewPlansModal.vue?vue&type=template&id=71edb03a&scoped=true&"
import script from "./ViewPlansModal.vue?vue&type=script&lang=js&"
export * from "./ViewPlansModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewPlansModal.vue?vue&type=style&index=0&id=71edb03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71edb03a",
  null
  
)

component.options.__file = "ViewPlansModal.vue"
export default component.exports